import { enableProdMode, APP_INITIALIZER  } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { rootRoutes } from './app/root-routes';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from '@core/interceptors/auth.interceptor';
import { DashboardSearchService } from '@booking/dashboard/services/dashboard-search.service';
import { DashboardService } from '@booking/dashboard/services/dashboard.service';
import { BookResearchIntervuService } from '@booking/intervu/services/book-a-project-intervu.service';
import { IntervuService } from '@booking/intervu/services/intervu.service';
import { BookResearchVisionService } from '@booking/vision/services/book-a-project-vision.service';
import { RequestAQuoteVisionService } from '@booking/vision/services/request-a-quote-vision.service';
import { AuthenticationService } from '@core/services/auth.service';
import { BookingConfigurationService } from '@core/services/booking-configuration.service';
import { HttpClientService } from '@core/services/http-client.service';
import { RouteDataService } from './app/route-data.service';
import { VisionService } from '@booking/vision/services/vision.service';
import { BookingService } from '@booking/booking.service';
import { RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
import { RequestAQuoteIntervuService } from '@booking/intervu/services/request-a-quote-intervu.service';
import { stateInterceptor } from '@core/interceptors/state.interceptor';
import { SpinnerService } from '@core/services/spinner.service';
import { FeatureFlagService } from '@core/services/feature-flag.service';
import { take } from 'rxjs';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (featureFlagService: FeatureFlagService) => {
        return () => {
          featureFlagService.loadFlags();
          return featureFlagService.flags$.pipe(take(1)).subscribe();
        }
      },
      deps: [FeatureFlagService],
      multi: true
    },
    provideRouter(rootRoutes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([stateInterceptor, authInterceptor])),
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.recaptcha.siteKey
      } as RecaptchaSettings
    },
    HttpClientService,
    AuthenticationService,
    BookingService,
    IntervuService,
    VisionService,
    RouteDataService,
    BookResearchIntervuService,
    BookResearchVisionService,
    BookingConfigurationService,
    RequestAQuoteIntervuService,
    RequestAQuoteVisionService,
    DashboardService,
    DashboardSearchService,
    SpinnerService,
    FeatureFlagService,
  ],
}).catch(err => console.error(err));
